export enum OrderStatus {
  Confirmed = 'confirmed',
  Invoiced = 'invoiced',
  Completed = 'completed',
  Delivered = 'delivered',
  Shipped = 'shipped',

  Processing = 'processing',
  Allocated = 'allocated',
  Pending = 'pending',
  Reserved = 'reserved',

  Open = 'open',

  FullyRejected = 'fully rejected',
  NotDelivered = 'not delivered',
  PartiallyDelivered = 'partially delivered',
  PartiallyShipped = 'partially shipped',
  Cancelled = 'cancelled',
}

export const enum OrderStatusType {
  Success = 'success',
  Pending = 'pending',
  Failed = 'failed',
  Warning = 'warning',
  New = 'new',
}
